import { CreateUserDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class UserResponseModel extends GlobalResponseObject{
    data?: CreateUserDto;
    success?: boolean;
}
